module.exports = __webpack_public_path__ + "img/Lets-play-to-01.88275103.jpg";